// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"605":"a55cca56","881":"d0075f58"}[chunkId] + ".css";
};